
   document.addEventListener("DOMContentLoaded", function() {
       // script of header popup  of klaviyo form
              // const openButton = document.querySelector(".open-klaviyo-popup");
              // const closeButton = document.getElementById("close-klav");
              // const popup = document.getElementById("klaviyo-popup");
              // const body = document.body;

              // openButton.addEventListener("click", function() {
              //     popup.classList.remove("hidden");
              //     body.classList.add("klaviyo-body-open");
              // });

              // closeButton.addEventListener("click", function() {
              //     popup.classList.add("hidden");
              //     body.classList.remove("klaviyo-body-open");
              // });

  // ///////////////////////////////mobile  hide background icon when  open search

    const searchIcon = document.querySelector('.header-search-icon-ham');
    const searchForm = document.querySelector('.header-search-form-ham');
    const closeIcon = document.querySelector('.header-close-search-icon');
    const elementsToHide = document.querySelectorAll('.hide-when-search-open');

    searchIcon.addEventListener('click', function(event) {
      event.preventDefault();
      searchForm.style.display = 'block';
      elementsToHide.forEach(function(element) {
        element.style.display = 'none';
      });
    });

    closeIcon.addEventListener('click', function(event) {
      event.preventDefault();
      searchForm.style.display = 'none';
      elementsToHide.forEach(function(element) {
        element.style.display = '';
      });

      
    });


     //  add active class to li when open dropdown




















     
 });